export default __webpack_public_path__ + "static/media/Screenshot_16.997d3075.png";